/* Outback free Magnesium+ gift: one $0 bottle on every cart with $60+ of paid items.
   Loaded on every storefront layout (cart drawer section on theme.liquid pages, plus ob-fast, ob-lander, ob-offer).
   Wraps window.fetch: after any successful POST to /cart/add, /cart/change, /cart/update or /cart/clear it makes the
   gift line match the cart BEFORE the caller's promise resolves, so pages that add to cart and jump straight to
   /checkout (fast PDPs, offer pages) carry the gift too. Gift variant is priced $0 (compare-at $29.95), no discount code.
   Threshold uses the cart total after discount codes in the cart. Fires document event 'ob:gift' (detail 'added' | 'removed' | 'fixed') when it changes the cart. No dependencies. */
(function(){
  'use strict';
  if(window.OBGift||!window.fetch||!window.Promise)return;
  var VID=44945963548714, MIN=6000, MAXWAIT=4000;
  var of=window.fetch.bind(window), H={'Content-Type':'application/json','Accept':'application/json'};
  var RE=/\/cart\/(add|change|update|clear)(\.js)?$/;
  var q=Promise.resolve();

  function post(u,b){return of(u,{method:'POST',credentials:'same-origin',headers:H,body:JSON.stringify(b)});}
  function run(){
    return of('/cart.js',{credentials:'same-origin',headers:{'Accept':'application/json'}})
    .then(function(r){if(!r.ok)throw new Error('cart '+r.status); return r.json();})
    .then(function(c){
      /* Paid = cart total after every discount already in the cart (line and cart level), gift line excluded */
      var giftTotal=0, lines=[];
      (c.items||[]).forEach(function(it){ if(it.variant_id===VID){lines.push(it); giftTotal+=it.final_line_price;} });
      var paid=(c.total_price||0)-giftTotal;
      var ok=paid>=MIN&&(c.attributes||{})._ob_gift!=='declined';
      if(ok&&!lines.length){
        return post('/cart/add.js',{items:[{id:VID,quantity:1,properties:{_ob_gift:'mg-60'}}]}).then(function(r){return r.ok?'added':'';});
      }
      if(lines.length&&(!ok||lines.length>1||lines[0].quantity!==1)){
        var u={}; lines.forEach(function(it,i){u[it.key]=(ok&&i===0)?1:0;});
        return post('/cart/update.js',{updates:u}).then(function(r){return r.ok?(ok?'fixed':'removed'):'';});
      }
      return '';
    })
    .catch(function(){return '';})
    .then(function(ch){
      if(ch){try{document.dispatchEvent(new CustomEvent('ob:gift',{detail:ch}));}catch(e){}}
      return ch;
    });
  }
  /* Serialized so two quick cart calls never race each other */
  function sync(){var p=q.then(run); q=p.catch(function(){}); return p;}

  window.fetch=function(input,init){
    var p=of(input,init);
    try{
      var url=typeof input==='string'?input:(input&&input.url)||String(input||'');
      var m=String((init&&init.method)||(input&&typeof input==='object'&&input.method)||'GET').toUpperCase();
      var path=url.replace(/^https?:\/\/[^\/]+/i,'').split(/[?#]/)[0];
      if(m!=='POST'||!RE.test(path))return p;
    }catch(e){return p;}
    return p.then(function(res){
      if(!res||!res.ok)return res;
      var t=new Promise(function(r){setTimeout(r,MAXWAIT);});
      return Promise.race([sync(),t]).then(function(){return res;},function(){return res;});
    });
  };
  /* Checkout hand-off for pages that jump straight to /checkout?discount=CODE (fast PDPs, offer pages).
     The layouts rewrite their `location.href=` to `(window.OBNav||location).href=`, so the code is applied to the
     cart first, the gift is re-checked against the discounted total, and only then does the browser go to checkout.
     Fixes: 3 creams ($49.85) + roll-on made free by CREAMROLLON at checkout was getting the gift on a $71.80 cart. */
  function go(url){
    var u; try{u=new URL(String(url),location.href);}catch(e){location.href=url;return;}
    if(u.origin!==location.origin||!/^\/checkout/.test(u.pathname)){location.href=url;return;}
    var code=u.searchParams.get('discount'), done=false;
    function nav(){if(done)return; done=true; location.href=url;}
    setTimeout(nav,MAXWAIT+2000);
    (code?post('/cart/update.js',{discount:code}).catch(function(){}):Promise.resolve())
      .then(function(){return sync();}).then(nav,nav);
  }
  window.OBNav={get href(){return location.href;},set href(u){go(u);}};
  window.OBGift={sync:sync,go:go,variantId:VID,min:MIN};
})();
